import { SummaryTabMenu } from "../../components/v2/insights/Summary/SummaryTabMenu";
import { SummaryView } from "../../components/v2/insights/Summary/SummaryView";
import { PageContainer } from "../../components/v2/PageContainer";
import React, { useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { DetailedView } from "../../components/v2/insights/Summary/DetailedView";
import { HintsAndErrorView } from "../../components/v2/insights/Summary/HintsAndErrorView";
import { FeedbackSelectedTarget } from "../../components/v2/insights/Summary/FeedbackSelectedTarget";
import { UserContext } from "../../context/UserContext";
import { CourseStructureCtx, InsightsCtx, InsightsView, UserCtx } from "../../interfaces";
import { InsightsHomeHeader } from "../../components/v2/insights/Home/Header";
import { InsightsContext } from "../../context/InsightsContext";
import { CourseStructureContext } from "../../context/CourseStructureContext";

// import { InsightsProgressFilterContext } from "../../context/InsightsProgressFilterContext";

export interface ITab {
  label: string;
  id: string;
  route?: string;
  tab: number;
  isHidden?: boolean;
}

export const InsightsSummaryPage = ({
  tab = 0,
  view = "class",
}: {
  tab?: number;
  view?: InsightsView;
}) => {
  const history = useHistory();
  const userCtx = useContext(UserContext) as UserCtx;
  const insightsCtx = useContext(InsightsContext) as InsightsCtx;
  const insightsCtxref = React.useRef<InsightsCtx>(insightsCtx);
  const courseStructureCtx = useContext(CourseStructureContext) as CourseStructureCtx;

  const courseId = insightsCtx.classInfo?.course_id;
  const currentCourseModuleFilters = courseStructureCtx.getModuleFiltersInCourse(
    courseId ?? -1
  );
  const currentCourseModuleIds = currentCourseModuleFilters?.map((item) => item.id);

  const AVAILABLE_TABS: ITab[] = [
    {
      label: "Summary",
      id: "summary",
      route: "/insights/class/:class_id/summary",
      tab: 0,
    },
    {
      label: "Detailed View",
      id: "details",
      route: "/insights/class/:class_id/details",
      tab: 1,
    },
  ];

  if (!insightsCtx.classInfo?.course_metadata?.insights_page?.disable_feedback_data) {
    AVAILABLE_TABS.push({
      label: "Hints/Errors",
      id: "overall",
      route: "/insights/class/:class_id/hints-and-errors",
      tab: 2,
    });
  }

  // const insightsFilterCtx = useContext(
  //   InsightsProgressFilterContext
  // ) as InsightsFilterCtx;

  // const [classId, setClassId] = React.useState<string>(classId);

  const location = useLocation();
  const currentTab = tab;

  // const studentId = new URLSearchParams(location.search).get("studentId");
  // const currentStudentName = new URLSearchParams(location.search).get("studentName");
  const feedbackTargetId = new URLSearchParams(location.search).get("targetId");
  const feedbackTargetName = new URLSearchParams(location.search).get("targetName");
  // const [classDetails, setClassDetails] = React.useState<ClassExtended>(
  //   {} as ClassExtended
  // );
  // const [headerTitle, setHeaderTitle] = React.useState<string>("");
  // const [currentStudentId, setCurrentStudentId] = React.useState<string | null>(
  //   studentId
  // );
  const updatingViewDate = React.useRef<boolean>(false);
  const handleChangeTab = (event: React.SyntheticEvent, newTab: ITab) => {
    // history.push({
    //   search: `?tab=${newTab}`,
    // });
    if (!insightsCtx.classId) return;

    history.push(
      newTab.route?.replace(":class_id", `${insightsCtx.classId}`) +
        history.location.search
    );
    // insightsFilterCtx.setSummaryBackOverride(false);
  };

  // prevent admins and supers from accessing insights in a course with no insights
  useEffect(() => {
    const classInfo = insightsCtx.classInfo;
    const userInfo = insightsCtx.userInfo;
    const metadata = classInfo?.course_metadata;

    function getClassIdFromPath() {
      const match = location.pathname.match(/\/insights\/class\/([^/]+)(\/|$)/);
      return match ? match[1] : undefined;
    }
    const pathClassId = getClassIdFromPath();

    if (view === "class") {
      console.log(classInfo?.id, insightsCtx.classId);
      if (`${classInfo?.id}` !== `${pathClassId}` || !pathClassId) return;
      if (metadata?.exclude_from_insights) {
        history.replace(`/insights/class/${pathClassId}/students`);
      }
    } else if (view === "student") {
      if (`${userInfo?.id}` !== `${pathClassId}` || !pathClassId) return;
      if (metadata?.exclude_from_insights) {
        history.replace(
          `/insights/class/${pathClassId}/student/${insightsCtx.studentId}/students`
        );
      }
    }
  }, [
    insightsCtx.classInfo,
    insightsCtx.userInfo,
    view,
    insightsCtx.classId,
    insightsCtx.studentId,
    history,
    location.pathname,
  ]);

  // useEffect(() => {
  //   if (!classId) {
  //     history.push("/insights");
  //     return;
  //   }
  //   const getClassDetails = async () => {
  //     setLoading(true);
  //     try {
  //       let classes = await getClass(classId);
  //       setClassDetails(classes[0]);
  //       setHeaderTitle(
  //         `${classes[0].subject} ${classes[0].period_block} ${
  //           classes[0].start_date &&
  //           new Date(classes[0].start_date).toLocaleDateString("en-US", {
  //             timeZone: "UTC",
  //           })
  //         }`
  //       );
  //     } catch (e) {
  //       console.log(e);
  //     }
  //     setLoading(false);
  //   };
  //   getClassDetails();
  // }, [classId, history]);

  // update viewed_at field when visiting a class
  useEffect(() => {
    const updateViewDate = async () => {
      if (!updatingViewDate.current) {
        updatingViewDate.current = true;
        const newSettings = await userCtx.upsertUserClassSettings(
          Number(insightsCtx.classId),
          {}
        );
        if (newSettings) {
          insightsCtxref.current.updateCachedClassSettings(newSettings);
        }
        updatingViewDate.current = false;
      }
    };
    if (insightsCtx.classId && !updatingViewDate.current) {
      updateViewDate();
    }
  }, [insightsCtx.classId, userCtx]);

  // const getObserverMessage = (studentMode: boolean) => {
  //   const userId = userCtx.dbUser.id;
  //   if (classDetails.observer_ids?.includes(userId)) {
  //     if (classDetails.class_observer_ids?.includes(userId)) {
  //       return "You are currently an observer for this class.";
  //     } else if (classDetails.student_observer_ids?.includes(userId)) {
  //       return studentMode
  //         ? "You are currently an observer for this student."
  //         : "You are currently an observer for student(s) in this class.";
  //     }
  //   }
  //   return "";
  // };

  if (
    insightsCtx.classId &&
    insightsCtx.classId === insightsCtx.classInfo?.id &&
    currentCourseModuleIds &&
    currentCourseModuleIds.length > 0
  ) {
    return (
      <>
        {/*<Header*/}
        {/*  showBack={showBack}*/}
        {/*  schoolId={classDetails.school_id}*/}
        {/*  teacherId={classDetails.teacher_id}*/}
        {/*  title={currentStudentId && currentStudentName ? currentStudentName : headerTitle}*/}
        {/*  teacher={classDetails.teacher_name}*/}
        {/*  observing={getObserverMessage(currentStudentId ? true : false)}*/}
        {/*  lastUpdatedDate={new Date().toLocaleString("en-US", {*/}
        {/*    timeZone: "MST",*/}
        {/*    month: "long",*/}
        {/*    day: "numeric",*/}
        {/*    year: "numeric",*/}
        {/*    hour: "numeric",*/}
        {/*    minute: "numeric",*/}
        {/*  })}*/}
        {/*  reportType={*/}
        {/*    currentStudentId && currentStudentName*/}
        {/*      ? INSIGHTS_SUMMARY_REPORT_TYPE.STUDENT*/}
        {/*      : INSIGHTS_SUMMARY_REPORT_TYPE.CLASS*/}
        {/*  }*/}
        {/*/>*/}
        <InsightsHomeHeader
          classId={insightsCtx.classId}
          showDownloadButton={true}
          view={view}
          studentHeader={insightsCtx.userInfo?.full_name}
        />
        {view === "class" && (
          <SummaryTabMenu
            classId={insightsCtx.classId}
            availableTabs={AVAILABLE_TABS}
            value={currentTab}
            handleChange={handleChangeTab}
          />
        )}
        <PageContainer>
          {currentTab === 0 && (
            <SummaryView
              view={view}
              classId={insightsCtx.classId}
              defaultModuleIds={currentCourseModuleIds}
              studentId={insightsCtx.studentId}
              classDetails={insightsCtx.classInfo}
              studentDetails={insightsCtx.userInfo}
              courseMetadata={insightsCtx.classInfo.course_metadata}
            />
          )}
          {currentTab === 1 && (
            <DetailedView
              defaultModuleIds={currentCourseModuleIds}
              classId={insightsCtx.classId}
              classDetails={insightsCtx.classInfo}
              courseMetadata={insightsCtx.classInfo.course_metadata}
            />
          )}
          {currentTab === 2 && !feedbackTargetId && (
            <HintsAndErrorView
              defaultModuleIds={currentCourseModuleIds}
              classId={insightsCtx.classId}
              classDetails={insightsCtx.classInfo}
              courseMetadata={insightsCtx.classInfo.course_metadata}
            />
          )}
          {currentTab === 2 && feedbackTargetId && feedbackTargetName && (
            <FeedbackSelectedTarget
              defaultModuleIds={currentCourseModuleIds}
              target={feedbackTargetId}
              classId={insightsCtx.classId}
              targetName={feedbackTargetName}
              classDetails={insightsCtx.classInfo}
              courseMetadata={insightsCtx.classInfo.course_metadata}
            />
          )}
        </PageContainer>
      </>
    );
  } else {
    return <></>;
  }
};
